<template>
  <div class="wk-company-select">
    <crm-select
      :value="value"
      filterable
      remote
      :disabled="disabled"
      :clearable="clearable"
      :remote-method="queryCustomerName"
      :placeholder="placeholder"
      style="width: 100%;"
      @change="valueChange">
      <el-option
        v-for="(item, index) in options"
        :key="index"
        :label="!isEmptyValue(item.value) ? item.label || item.name : item "
        :value="getValue(item)" />
    </crm-select>
  </div>
</template>

<script>
import { isObject, isEmpty, isArray } from '@/utils/types'
import Emitter from 'element-ui/lib/mixins/emitter'
import { crmEnterpriseListAPI } from '@/api/premium/businessInfo'

export default {
  // 自定义字段库 搜索并选择企业名称
  name: 'WkCompanySelect',

  components: {},

  mixins: [Emitter],

  props: {
    value: [String, Number],
    disabled: Boolean,
    clearable: Boolean,
    placeholder: String
  },

  data() {
    return {
      options: []
    }
  },

  computed: {

  },

  created() {
  },

  mounted() {},

  beforeDestroy() {},

  methods: {
    /**
     * @description: 客户名称搜索
     * @param {*} queryString 搜索字符串
     * @return {*}
     */
    queryCustomerName(queryString) {
      if (queryString !== '') {
        crmEnterpriseListAPI(queryString).then(res => {
          const reaData = res.data || []
          this.options = reaData.map(item => {
            return { label: item.name, value: item.name }
          })
        }).catch(() => {
        })
      } else {
        this.options = []
      }
    },

    /**
     * 选项值
     */
    getValue(item) {
      return !this.isEmptyValue(item.value) ? item.value : item
    },

    /**
     * 判断是空值
     */
    isEmptyValue(value) {
      return value === null || value == undefined
    },

    /**
     * 值更新
     */
    valueChange(value) {
      console.log(value)
      this.$emit('input', value)
      this.$emit('change', value)
      this.dispatch('ElFormItem', 'el.form.change', value)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
